import { FlagKeys } from 'constants/flags'
import { OperationsSortCriteria } from '../tab-panels/UsageMetrics/types'

export interface DevToolsSettingsState {
  general: {
    isTurnedOn: boolean
  }
  ui: {
    isVisible: boolean
    isPinned: boolean
    pinnedTo: 'left' | 'right'
    width: number
    selectedTab: number
  }
  featureFlags: { overrides: { [flag in FlagKeys]?: boolean } }
  usageMetrics: {
    isTurnedOn: boolean
    selectedTab: number
    sortFieldPathsBy: 'costs' | 'none'
    filter: string
    sortBy: OperationsSortCriteria
  }
  webRenderer: {
    mode: 'release' | 'debug'
    showTilesBorders: boolean
  }
}

export const defaultValues: DevToolsSettingsState = {
  general: { isTurnedOn: false },
  featureFlags: { overrides: {} },
  ui: {
    isPinned: false,
    pinnedTo: 'left',
    width: 800,
    selectedTab: 0,
    isVisible: false,
  },
  usageMetrics: {
    isTurnedOn: false,
    selectedTab: 0,
    sortFieldPathsBy: 'costs',
    filter: '',
    sortBy: OperationsSortCriteria.DEFAULT,
  },
  webRenderer: {
    mode: 'release',
    showTilesBorders: false,
  },
}

export type DeepPartial<T> = {
  [P in keyof T]?: DeepPartial<T[P]>
}

export type PartialDevToolsSettings = DeepPartial<DevToolsSettingsState>
